var featureGateManager;
export var setFeatureGateManager = function (manager) {
    featureGateManager = manager;
};
export var getIntFeatureGate = function (featureGateName, defaultValue) {
    if (!featureGateManager) {
        return defaultValue;
    }
    return featureGateManager.getIntFeatureGate(featureGateName, defaultValue);
};
export var getBooleanFeatureGate = function (featureGateName, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (!featureGateManager) {
        return defaultValue;
    }
    return featureGateManager.getBooleanFeatureGate(featureGateName, defaultValue);
};
export var getStringFeatureGate = function (featureGateName, defaultValue) {
    if (!featureGateManager) {
        return defaultValue;
    }
    return featureGateManager.getStringFeatureGate(featureGateName, defaultValue);
};
//# sourceMappingURL=featureGates.js.map